import { useQuery } from '@tanstack/react-query';
import { SideNavItem } from '../../components/SideNav/SideNav';

export const fetchFromLocalStorage = (localStorageKey: string) => {
  return () => {
    const localSideNav = localStorage.getItem(localStorageKey);
    if (!localSideNav) {
      return [];
    }
    try {
      const reportNav = JSON.parse(localSideNav) as SideNavItem[];
      return reportNav;
    } catch (error) {
      console.error('Error parsing localStorage data:', error);
      return [];
    }
  };
};

export const useLocalStorageQuery = (localStorageKey: string) => {
  return useQuery<SideNavItem[]>({
    queryKey: [localStorageKey],
    queryFn: fetchFromLocalStorage(localStorageKey),
  });
};
